import http from '../utils/http';

export const login = (acctount, password,tenantId) => 
{
  return http.post(`/api/Authorize/GetToken`,{ name:acctount, passWord: password,tenantId:tenantId });
};
export const getTokenUser = () => {
  return http.get(`/api/User/GetUser`);
};

export const createUser = (userData) => {
  return http.post('/api/User/EditUser', userData);
};

export const updateUser = (userData) => {
  return http.post(`/api/User/EditUser`, userData);
}; 

export const getUserList = (params) => {
  return http.post('/api/User/GetSysUserList', params);
};

export const getUserRoleList = () => {
  return http.get('/api/User/GetUserRoleKey');
};
 
export const DeleteUser = (id) => {
  return http.delete('/api/User/DeleteUser?id='+id);
};

export const ExportGetSysUserList = (params) => {
  return http.post('/api/User/ExportGetSysUserList', params,{ responseType: 'blob' });
};

// 修改密码接口
export const changePassword = (data) => {
  return http.post('/api/User/ChangePasswordTokenUser', data);
};

// 获取用户总数接口
export const getAllUserCount = () => {
  return http.get('/api/User/GetAllUserCount');
};

// 发送短信验证码（外部登录）
export const sendSmsCode = (phone) => {
  return http.post('/api/Authorize/SendExternalSms', { key: phone, value: '' });
};

// 手机号验证码登录
export const loginByPhone = (phone, code) => {
  return http.post('/api/Authorize/GetTokenBySms', { key: phone, value: code })
}

export const oauthAuthorize = (params) => {
  const formData = new FormData()
  if (params.client_id) formData.append('client_id', params.client_id)
  if (params.redirect_uri) formData.append('redirect_uri', params.redirect_uri)
  if (params.state) formData.append('state', params.state)
  if (params.response_type) formData.append('response_type', params.response_type)
  if (params.code_challenge) formData.append('code_challenge', params.code_challenge)
  if (params.code_challenge_method) formData.append('code_challenge_method', params.code_challenge_method)
  return http.post('/oauth/authorize', formData, {
    headers: { 
      'Content-Type': 'multipart/form-data'
     },
    responseType: 'text'
  })
}